import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ShowDialogParams } from '@/store/dialog/types';
import {
    getEditorTemplateObjectStore,
    IncrementAutosaveCounter,
    SetDefaultOptions,
} from '@/store/templateEditor/actions';
import { DefaultOptionsModalBody } from '../components/DefaultOptionsModalBody';

export const useDefaultOptionsModalParams = (): {
    getDefaultOptionsModalParams: () => ShowDialogParams;
} => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const templateObject = useSelector(getEditorTemplateObjectStore);

    const getDefaultOptionsModalParams = (): ShowDialogParams => {
        let newSubject;
        let newFromEmail;
        let newFromName;
        const updateSubject = (text: string): void => {
            newSubject = text;
        };
        const updateFromEmail = (text: string): void => {
            newFromEmail = text;
        };
        const updateFromName = (text: string): void => {
            newFromName = text;
        };
        const body = (
            <DefaultOptionsModalBody
                templateObject={templateObject}
                onSubjectChange={updateSubject}
                onFromEmailChange={updateFromEmail}
                onFromNameChange={updateFromName}
            />
        );
        const saveValues = (): void => {
            dispatch(
                SetDefaultOptions({
                    subject: newSubject,
                    fromEmail: newFromEmail,
                    fromName: newFromName,
                })
            );
            dispatch(IncrementAutosaveCounter());
        };
        return {
            title: t('editdefaults'),
            confirmLabel: t('save'),
            cancelLabel: t('cancel'),
            onClickConfirm: saveValues,
            body,
            id: 'editdefaults',
        };
    };
    return { getDefaultOptionsModalParams };
};
